import type { Module } from 'vuex';
import { Blockchain } from '@/types/Blockchain';
import {RootState} from "@/store";

export interface BlockchainState {
  blockchain: Blockchain | null;
  deleted: boolean;
}

const blockchainModule: Module<BlockchainState, RootState> = {
  namespaced: true,

  state: (): BlockchainState => ({
    blockchain: null,
    deleted: false,
  }),

  getters: {
    getBlockchain: (state): Blockchain | null => {
      return state.blockchain;
    },
    isDeleted: (state): boolean => {
      return state.deleted;
    },
  },

  mutations: {
    setBlockchain(
      state,
      payload: { blockchain: any | null }
    ) {
      if (payload.blockchain === null) {
        state.blockchain = null;
        state.deleted = false;
        return;
      }
      state.blockchain = Blockchain.fromRaw(payload.blockchain);
      state.deleted = false;
    },

    setBlockchainUpdate(
      state,
      payload: {
        idBlockchain: number;
        name?: string;
        preg?: string;
        tag?: boolean;
        decimalPlace?: number;
        locked?: boolean;
      }
    ) {
      if (!state.blockchain || state.blockchain.idBlockchain !== payload.idBlockchain) return;
      if (payload.name !== undefined) state.blockchain.name = payload.name;
      if (payload.preg !== undefined) state.blockchain.preg = payload.preg;
      if (payload.tag !== undefined) state.blockchain.tag = payload.tag;
      if (payload.decimalPlace !== undefined) state.blockchain.decimalPlace = payload.decimalPlace;
      if (payload.locked !== undefined) state.blockchain.locked = payload.locked;
    },

    setBlockchainDelete(
      state,
      payload: { idBlockchain: number }
    ) {
      if (!state.blockchain || state.blockchain.idBlockchain !== payload.idBlockchain) return;
      state.deleted = true;
    },

    setBlockchainLock(
      state,
      payload: { idBlockchain: number }
    ) {
      if (!state.blockchain || state.blockchain.idBlockchain !== payload.idBlockchain) return;
      state.blockchain.locked = true;
    },

    setBlockchainUnlock(
      state,
      payload: { idBlockchain: number }
    ) {
      if (!state.blockchain || state.blockchain.idBlockchain !== payload.idBlockchain) return;
      state.blockchain.locked = false;
    },

    clearBlockchain(state) {
      state.blockchain = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetBlockchain({ commit }, payload) {
      commit('setBlockchain', payload);
    },
    wsBlockchainUpdate({ commit }, payload) {
      commit('setBlockchainUpdate', payload);
    },
    wsBlockchainDelete({ commit }, payload) {
      commit('setBlockchainDelete', payload);
    },
    wsBlockchainLock({ commit }, payload) {
      commit('setBlockchainLock', payload);
    },
    wsBlockchainUnlock({ commit }, payload) {
      commit('setBlockchainUnlock', payload);
    },
    clearBlockchain({ commit }) {
      commit('clearBlockchain');
    },
    wsSetEmptyBlockchain({ commit }) {
      commit('setBlockchain', { blockchain: null });
    },
  },
};

export default blockchainModule;
